import Route from "./Routes/Route";
import "./App.css";
import React from "react";
import ReactGA from "react-ga4";
import Context from "./context/AppContext";
import InstallPWA from "./Components/InstallPWA";
import CookieConsent from "./Components/CookieConsent"; // Import CookieConsent
import WhatsAppButton from "./Components/WhatsAppButton"; // Import WhatsAppButton

const initGA = () => {
  ReactGA.initialize("G-GWX8V6DWK3"); // Replace with your actual GA tracking ID
};
function App() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  }
  return (
    <div className="mains">
      <Context>
        {/* <CookieConsent /> */}
        <Route />
      </Context>
      {/* <WhatsAppButton />  */}
    </div>
  );
}

export default App;
